module.exports = __webpack_public_path__ + "img/Logo_435001.5fc46d0f.jpeg";